import type { Epic } from 'Flux/index.js'
import { filter, mergeMap, of, withLatestFrom } from 'rxjs'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { catchError, retryWhen } from 'rxjs/operators'
import { serverIsNotAvailable } from 'Framework/Epic/ServerNotAvailable.js'
import { authenticationExpiredOr } from 'Framework/Epic/AuthenticationExpired.js'
import { withBlockingRequest } from 'Flux/Epic/Application/withBlockingRequest.ts'

export const CreateOrderEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.createOrderRequest.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) =>
      withBlockingRequest(
        OrderRepository.createOrder(action.payload, state.authentication.user).pipe(
          mergeMap((response) => of(order.createOrderSuccess(response))),
          retryWhen(serverIsNotAvailable()),
          catchError((error) =>
            authenticationExpiredOr({
              error,
              failedRequest: action.type,
              failureAction: of(order.createOrderFailure({ error }))
            })
          )
        ),
        'Creating Order',
        'Please wait'
      )
    )
  )
